import { inRange } from "./Number";
export function slavicPluralize(count, one, few, many) {
    function inPluralRange(number, low, high) {
        return inRange(count % 10, low, high) && !inRange(number, 10, 19);
    }
    if (inPluralRange(count, 1, 1))
        return one;
    if (inPluralRange(count, 2, 4))
        return few;
    return many;
}
